// ReportTemplatesGrid — modelos de relatorio previstos (estrutura, nao relatorios gerados)
import { useState } from "react";
import { reportTemplates } from "@/config/relat-oper-ladm-relatorios-config";

export default function ReportTemplatesGrid() {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {reportTemplates.map((tpl) => {
        const isExpanded = expandedId === tpl.id;
        return (
          <div
            key={tpl.id}
            className={`bg-white rounded-xl border transition-colors ${
              isExpanded ? "border-primary-300" : "border-background-200/70 hover:border-primary-200"
            }`}
          >
            <div className="p-4">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center shrink-0">
                  <i className={`${tpl.icon} text-primary-500 w-full h-full flex items-center justify-center text-lg`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-foreground-900 text-sm">{tpl.name}</h4>
                  <p className="text-xs text-foreground-400 mt-1 line-clamp-2">{tpl.purpose}</p>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-2 mb-3">
                {tpl.formats.map((f) => (
                  <span key={f} className="text-xs font-medium text-accent-600 bg-accent-50 px-2 py-0.5 rounded">{f}</span>
                ))}
              </div>

              <p className="text-xs text-foreground-500 mb-3">
                <i className="ri-user-line w-3 h-3 inline-flex items-center justify-center mr-1" />
                {tpl.audience}
              </p>

              {isExpanded && (
                <div className="border-t border-background-100 pt-3 mt-3 space-y-2 animate-fade-in">
                  <p className="text-xs font-semibold text-foreground-700">Seções incluídas:</p>
                  <div className="flex flex-wrap gap-1">
                    {tpl.sections.map((s, i) => (
                      <span key={i} className="text-xs bg-background-50 text-foreground-600 px-2 py-0.5 rounded border border-background-200">{s}</span>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="flex items-center gap-1 px-4 py-3 border-t border-background-100">
              <button
                onClick={() => setExpandedId(isExpanded ? null : tpl.id)}
                className="flex-1 px-3 py-1.5 text-xs font-medium text-secondary-600 bg-secondary-50 rounded-lg hover:bg-secondary-100 transition-colors whitespace-nowrap text-center"
              >
                <i className={`${isExpanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} w-3.5 h-3.5 inline-flex items-center justify-center mr-1`} />
                {isExpanded ? "Menos" : "Detalhes"}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}